import { render, staticRenderFns } from "./StatGrid.vue?vue&type=template&id=a00f61a0&scoped=true&"
import script from "./StatGrid.vue?vue&type=script&lang=ts&"
export * from "./StatGrid.vue?vue&type=script&lang=ts&"
import style0 from "./StatGrid.vue?vue&type=style&index=0&id=a00f61a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00f61a0",
  null
  
)

export default component.exports